import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  whiteBox: {
    marginBottom: '20px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '1px solid lightgray',
    padding: '10px',
    width: '100%',
  },
  whiteBoxMobile: {
    marginBottom: '10px',
    backgroundColor: 'white',
    borderRadius: '10px',
    border: '1px solid lightgray',
    overflow: 'hidden',
  },
  timeline: {
    display: 'flex',
    overflow: 'auto',
    justifyContent: 'space-between',
    padding: '15px 30px 15px 15px',
    alignItems: 'center',
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
  },
  separator: {
    display: 'flex',
    flex: 1,
    height: '1px',
    backgroundColor: 'lightgray',
    margin: '0px 20px',
  },
  transparentSeparator: {
    width: '100%',
    height: '1px',
    margin: '0px 20px',
  },
  circle: {
    width: '30px',
    height: '30px',
    minWidth: '30px',
    borderRadius: '25px',
    backgroundColor: '#21a1f9',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleRed: {
    width: '30px',
    height: '30px',
    minWidth: '30px',
    borderRadius: '25px',
    backgroundColor: '#e6005a',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleGray: {
    width: '30px',
    height: '30px',
    minWidth: '30px',
    borderRadius: '25px',
    backgroundColor: '#adadad',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  circleGreen: {
    width: '30px',
    height: '30px',
    minWidth: '30px',
    borderRadius: '25px',
    backgroundColor: 'green',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconCircle: {
    color: 'white',
    width: '20px',
  },
  statusText: {
    marginLeft: '10px',
  },
  statusNumber: {
    color: 'white',
    fontSize: '16px',
  },
  dateText: {
    marginLeft: '10px',
    color: 'gray',
  },
  signedStatusBadge: {
    backgroundColor: '#27AE60',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '30px',
    height: '30px',
    borderRadius: '30px',
    '& > svg': {
      width: '30px',
      height: '30px',
    },
  },
  skippedPhaseText: {
    color: '#9e9e9e',
  },
});

